export const DOWNLOAD_ERROR = 'Oops! Something went wrong. Failed to get site records. Please try it again later.';
